// DAS-3238: the Advice pipeline page's hovers (pure; used by AdvicePipelineModal.jsx).
// hoverText picks a box's text from the latest stored run (GET /api/advice_pipeline_content/<user>);
// zoneStyle places the invisible hover zone over the generated picture
// (positions from docs/Morning_Advice_Pipeline_Map.hover.json, served as data.hover).

export const hoverText = (zone, content) => {
  if (!content) return 'Loading the latest run…';
  if (zone.kind === 'block') {
    if (!content.blocks_stored) return 'Stored from the next morning run on (DAS-3238).';
    const t = content.blocks ? content.blocks[zone.key] : undefined;
    if (t === undefined) return 'Not part of the latest run.';
    return t.trim() ? t : 'Empty in the latest run: this block was not part of that day\'s prompt.';
  }
  const title = (zone.titles || []).find((x) => content.steps && content.steps[x]);
  return title ? content.steps[title] : 'Nothing stored for this step in the latest run.';
};

export const zoneStyle = (zone, hover) => ({
  left: `${(zone.x / hover.width) * 100}%`,
  top: `${(zone.y / hover.height) * 100}%`,
  width: `${(zone.w / hover.width) * 100}%`,
  height: `${(zone.h / hover.height) * 100}%`,
});
